import { injectedConnector as injected  , bsc ,walletconnect} from '../connectors'
import { AbstractConnector } from '@web3-react/abstract-connector'

export const NetworkContextName = 'NETWORK'
export const DEX_Address =  process.env.REACT_APP_DEX_ADDRESS
export const CUSTODIAN_ADDRESS = process.env.REACT_APP_CUSTODIAN_ADDRESS
export const GOV_TOKEN = process.env.REACT_APP_GOV_TOKEN
export const HOME_PAGE = process.env.REACT_APP_LANDING_URL
export const NAME_TOKEN = 'OneP'
export const PAGE_NAME = "https://swap.onepirate.finance/"
export const PAGE_SWAP_NAME =
  process.env.REACT_APP_PAGE_SWAP_NAME || window.location.host + '/swap/'
export const PAGE_AFFILIATE_NAME =
  process.env.REACT_APP_PAGE_AFFILIATE_NAME ||
  window.location.host + '/affiliate/'
export const VERSION = process.env.REACT_APP_VERSION || 1
export const BONUS_ADDRESS = process.env.REACT_APP_BONUS_ADDRESS
export const MIN_SWAP =  100

export declare enum ChainId {
    MAINNET = 56,
    BSCTESTNET = 97
}
export interface WalletInfo {
    connector?: AbstractConnector
    name: string
    iconName: string
    description: string
    href: string | null
    color: string
    primary?: true
    mobile?: true
    mobileOnly?: true
  }
  



export const SUPPORTED_WALLETS: { [key: string]: WalletInfo } = {
    // BSC: {
    //   connector: bsc,
    //   name: 'Binance Chain Wallet',
    //   iconName: 'binance.svg',
    //   description: 'Easy-to-use browser extension.',
    //   href: null,
    //   color: '#E8831D'
    // },
    // INJECTED: {
    //   connector: injected,
    //   name: 'Injected',
    //   iconName: 'arrow-right.svg',
    //   description: 'Injected web3 provider.',
    //   href: null,
    //   color: '#010101',
    //   primary: true
    // },
    METAMASK: {
      connector: injected,
      name: 'MetaMask',
      iconName: 'metamask.png',
      description: 'Easy-to-use browser extension.',
      href: null,
      color: '#E8831D'
    },
    WALLET_CONNECT: {
      connector: walletconnect,
      name: 'WalletConnect',
      iconName: 'walletConnectIcon.svg',
      description: 'Connect to Trust Wallet, Rainbow Wallet and more...',
      href: null,
      color: '#4196FC',
      mobile: true
    },
    // WALLET_LINK: {
    //   connector: walletlink,
    //   name: 'Coinbase Wallet',
    //   iconName: 'coinbaseWalletIcon.svg',
    //   description: 'Use Coinbase Wallet app on mobile device',
    //   href: null,
    //   color: '#315CF5'
    // },
    // COINBASE_LINK: {
    //   name: 'Open in Coinbase Wallet',
    //   iconName: 'coinbaseWalletIcon.svg',
    //   description: 'Open in Coinbase Wallet app.',
    //   href: 'https://go.cb-w.com/mtUDhEZPy1',
    //   color: '#315CF5',
    //   mobile: true,
    //   mobileOnly: true
    // },
    // FORTMATIC: {
    //   connector: fortmatic,
    //   name: 'Fortmatic',
    //   iconName: 'fortmaticIcon.png',
    //   description: 'Login using Fortmatic hosted wallet',
    //   href: null,
    //   color: '#6748FF',
    //   mobile: true
    // },
    // Portis: {
    //   connector: portis,
    //   name: 'Portis',
    //   iconName: 'portisIcon.png',
    //   description: 'Login using Portis hosted wallet',
    //   href: null,
    //   color: '#4A6C9B',
    //   mobile: true
    // }
  }